<template>
  <div class="form-group position-relative" v-if="IsShow">
    <div v-if="subTitle" class="TextAreaSubTitle">
      {{ $t(subTitle) }} 
      <span class="text-danger" v-if="isHideStar ? 
      !isHideStar : validationRules ?
      validationRules.required : validationRules
      ">*</span>
    </div>

    <h6 v-if="IsShowTitle">
      {{ $t(labelText)
      }}<span class="text-danger" v-if="isHideStar
    ? !isHideStar
    : validationRules
      ? validationRules.required
      : validationRules
  ">
        *</span>
    </h6>

    <div
      v-if="placeholderOnTopEnabled && shouldFloatTopPlaceholder && topPlaceholderText"
      class="TextAreaSubTitle TextAreaTopPlaceholder"
    >
      {{ topPlaceholderText }}
    </div>

    <validation-provider name="TextArea" :rules="validationRules" v-slot="validationContext"
      :vid="ControlId ? ControlId : ''">

      <div class="position-relative">
        <b-form-textarea ref="textarea" v-model="temp_value" @input="updateValue" @change="updateValue" @blur="checkValue"
          :state="getValidationState(validationContext)" v-bind="$attrs" :placeholder="(placeholderOnTopEnabled && shouldFloatTopPlaceholder) ? '' : ($attrs && $attrs['placeholder'] ? $attrs['placeholder'] : '')" class="form_textarea position-relative" :style="{'height': textareaHeight}">
        </b-form-textarea>

        <span v-if="$attrs && $attrs['max'] && $attrs['max'] > 0"
          class="word-count" :class="{ 'text-danger': wordCount.isError }">
          {{ wordCount.text }}
        </span>
      </div>

      <b-form-invalid-feedback v-if="getInvalidRules(validationContext)" :state="getValidationState(validationContext)">
        {{
            getInvalidRules(validationContext) === "required"
                ? $t(mandatoryText)
                : getInvalidRules(validationContext)
                ? customErrorMessage[getInvalidRules(validationContext)]
                : ""
        }}
        </b-form-invalid-feedback>
    </validation-provider>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: [
    "value",
    "ControlId",
    "isshow",
    "mandatory",
    "title",
    "isHideStar",
    "CharLimit",
    "isShowTitle",
    "subTitle",
    "autoHeight",
    "maxHeight",
    "noLengthCheckPopup",
    "customErrorMessage",
    "placeholderOnTop",
  ],
  data() {
    return {
      temp_value: this.value,
      IsShow: true,
      labelText: this.title,
      mandatoryText: this.mandatory,
      validationRules:
        this.rules == null
          ? this.mandatory == null
            ? null
            : {
                required: true,
                email: this.type == "email" ? true : false,
                max: (this.$attrs && this.$attrs["max"]) ?? 0,
                min: (this.$attrs && this.$attrs["min"]) ?? 0,
              }
          : this.rules,
      //[21022024][SJP] add subtitle / hide main title logic
      IsShowTitle : this.isShowTitle != null ? this.isShowTitle  : true ,

      textareaHeight: "auto",

    };
  },

  computed: {
    ...mapGetters({
      GetPermissionJsonById: "responsePermission/getPermissionJsonById",
    }),
    record() {
      return this.GetPermissionJsonById({ ControlId: this.ControlId });
    },
    wordCount() {
      const count = this.temp_value ? this.temp_value.length : 0;
      const max = this.$attrs["max"] ?? 0;

      return {
        text: `${count}/${max}`,
        isError: count > max,
      };
    },
    placeholderOnTopEnabled() {
      return this.placeholderOnTop === true
        || this.placeholderOnTop === ""
        || this.placeholderOnTop === "true"
        || this.placeholderOnTop === 1
        || this.placeholderOnTop === "1";
    },
    topPlaceholderText() {
      return (this.$attrs && this.$attrs["placeholder"]) ? this.$attrs["placeholder"] : "";
    },
    shouldFloatTopPlaceholder() {
      return this.temp_value !== null
        && this.temp_value !== undefined
        && String(this.temp_value).length > 0;
    },
  },
  mounted() {
    //read from json
    if (this.record != null) {
      if (this.record.IsShow != null) this.IsShow = this.record.IsShow;
      if (this.record.IsMandatory) this.validationRules = { required: true };
      if (this.record.IsDisable != null) this.$attrs["disabled"] = this.record.IsDisable;
      if (this.record.Label != null) this.labelText = this.$t(this.record.Label);
      if (this.record.PlaceholderLabel != null)
        this.$attrs["placeholder"] = this.$t(this.record.PlaceholderLabel);
      if (this.record.MandatoryLabel != null)
        this.mandatoryText = this.$t(this.record.MandatoryLabel);
      if (this.record.MaxLength != null) this.$attrs["max"] = this.record.MaxLength;
      if (this.record.MinLength != null) this.$attrs["min"] = this.record.MinLength;
      if (this.record.mutiPermission_IsMandatory != null) {
        switch (localStorage.getItem("currentLangId")) {
          case "1252":
            if (this.record.mutiPermission_IsMandatory.eng) {
              this.validationRules = {
                required: true,
                email: this.type == "email" ? true : false,
              };
            } else {
              this.validationRules = {};
            }
            break;
          case "950":
            if (this.record.mutiPermission_IsMandatory.trad) {
              this.validationRules = {
                required: true,
                email: this.type == "email" ? true : false,
              };
            } else {
              this.validationRules = {};
            }
            break;
          case "936":
            if (this.record.mutiPermission_IsMandatory.simp) {
              this.validationRules = {
                required: true,
                email: this.type == "email" ? true : false,
              };
            } else {
              this.validationRules = {};
            }
            break;
        }
      }
    }
  },
  watch: {
    value() {
      this.temp_value = this.value;
    },
    temp_value(newVal) {
      this.AdjustTextAreaHeight();
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getInvalidRules({ failedRules }) {
      const failedRuleNames = Object.keys(failedRules);
      return failedRuleNames.length > 0 ? failedRuleNames[0] : null;
    },
    updateValue(e) {
      //Check maxlength
      if (this.$attrs["max"] > 0) {
        this.CheckTextLimit();
      }
      //Check char CharOnly
      if (this.CharLimit == "CheckEnglishChar") {
        this.CheckEnglishChar();
      }
      //remove duplicate newline
      this.RemoveDuplicateNewLine();
      this.$emit("input", this.temp_value);
    },
    checkValue() {
      if (this.temp_value != undefined && this.temp_value.length > 0) {
        this.floatedLabel = true;
        this.$emit("blur", this.temp_value);
      } else {
        this.floatedLabel = false;
      }
    },
    CheckEnglishChar() {
      this.$nextTick(() => {
        this.temp_value = this.temp_value.replace("®", "");
        var partn = new RegExp("[^\w\s\.\/,-_.:;$+#@?!'%^&℃()~≤≥αβ‰μπφΩΦευ*™\"]", "gi");
        if (partn.exec(this.temp_value)) {
          this.temp_value = this.temp_value.replace(
            /[^\w\s\.\/,-_.:;$+#@?!'%^&℃()~≤≥αβ‰μπφΩΦευ*™\"]/gi,
            ""
          );
          this.$emit("input", this.temp_value);
        }
      });
    },
    CheckTextLimit() {
      if (this.noLengthCheckPopup) {
        return;
      }

      this.$nextTick(() => {
        //Check maxlength
        if (this.$attrs["max"] > 0) {
          if (this.temp_value.length > this.$attrs["max"]) {
            this.$swal({
              text: this.$t("lbl_EMPBE_ReachMaxLength"),
              showCancelButton: false,
              confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
            });
            this.temp_value = this.temp_value.slice(0, this.$attrs["max"]);
          }
        }
      });
    },
    RemoveDuplicateNewLine() {
      this.$nextTick(() => {
        this.temp_value = this.temp_value.replace(/\n\n(?=\n)/g, '');//obj.value.replace(/\t|\n|\v|\r|\f/g, '\n');
        this.temp_value = this.temp_value.replace(/\r\r(?=\r)/g, '');
          this.$emit("input", this.temp_value);
      })
    },
    AdjustTextAreaHeight() {
         // Reset height
        //因为其dom咋还没响应的时候就加载了,所以取dom的高度应是有一定的延时去做处理才行
        this.textareaHeight = 'auto';
          this.$nextTick(() => {
              const textareaScrollHeight = this.$refs.textarea.$el.scrollHeight;
              const defaultMaxHeight = this.maxHeight ?? 400;
              const targetScrollHeight = Math.min(defaultMaxHeight, textareaScrollHeight) + 2; // 2 for border
              this.textareaHeight = `${targetScrollHeight}px`; // Set new height
              this.$refs.textarea.$el.scrollTop = textareaScrollHeight; // auto scroll down
          });
       

    },
  },
};
</script>
<style lang="scss">
.TextAreaSubTitle{
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: -2px;
    font-size: 12px;
    padding: 0 5px;
    background: #fff;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
    z-index: 2;
    color: #151515;
    border-radius: 0.25rem;
}
.TextAreaTopPlaceholder{
    color: rgba(0, 0, 0, 0.5);
}

.form-group {
  .word-count {
    position: absolute;
    bottom: 0.25rem;
    right: 1.125rem;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 15px */
    letter-spacing: 0.15px;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.50);
  }
}
</style>
